import * as React from 'react';
import { useLocation } from 'react-router-dom';

// Uses global gtag function from index.html to register pageviews when location changes based on router data
// See https://javascript.plainenglish.io/the-ultimate-guide-to-google-analytics-ua-ga4-on-react-or-anything-else-ec9dc84c0211
interface AnalyticsWrapperProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: React.PropsWithChildren<any>;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function AnalyticsWrapper(props: AnalyticsWrapperProps) {

    const location = useLocation();

    React.useEffect(() => {
        // Send pageviews to our Google Analytics when location changes
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search + location.hash,
            page_search: location.search,
            page_hash: location.hash,
        });
    }, [location.pathname, location.search]);

    // Return the children involved with this wrapper
    return props.children;

}